import { Breadcrumbs, useMediaQuery } from '@mui/material';
import { useRouter } from 'next/router';
import { Icon } from '../Icon';
import BreadcrumbItem from './BreadcrumbItem';
import { getBreadCrumbClassName, getBreadCrumbProps } from './helper';
import { BreadcrumProps, BreadcrumbItemProps } from './types';

const Breadcrumb = (props: BreadcrumProps) => {
  const { breadcrumbItems, startPlace, className, ...restProps } = props;
  const router = useRouter();
  const { iconName } = startPlace;
  const isMobile = useMediaQuery('(max-width:425px)');

  const finalClassName = [getBreadCrumbClassName(), className].join(
    'overflow-hidden'
  );
  const isLengthOne = breadcrumbItems.length === 1;

  const renderStartPlace = (item: BreadcrumbItemProps) => (
    <div
      key={item.path.toString()}
      className="flex"
      onClick={() => router.push(item.path)}
    >
      {isMobile ? (
        <>
          <Icon iconName={iconName} width={20} height={20} />
          {isLengthOne && <BreadcrumbItem {...item} />}
        </>
      ) : (
        <>
          {isLengthOne && <Icon iconName={iconName} width={20} height={20} />}
          <BreadcrumbItem {...item} />
        </>
      )}
    </div>
  );

  return (
    <Breadcrumbs
      {...restProps}
      {...getBreadCrumbProps()}
      className={finalClassName}
    >
      {breadcrumbItems.map((item, index) => {
        const isLastItem = index + 1 === breadcrumbItems.length;
        const breadcrumbItemProps: BreadcrumbItemProps = {
          ...item,
          isLastItem,
        };

        if (index === 0)
          return renderStartPlace({
            ...breadcrumbItemProps,
          });

        return <BreadcrumbItem key={index} {...breadcrumbItemProps} />;
      })}
    </Breadcrumbs>
  );
};

export default Breadcrumb;
